import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, isRef as _isRef, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flex-fill position-relative" }
const _hoisted_2 = {
  class: "flex-fill position-relative",
  style: {"padding-top":"5em"}
}
const _hoisted_3 = { class: "d-flex history-delimiter align-items-center mt-2 mb-2 pt-2 pb-2 sticky -top" }
const _hoisted_4 = { class: "text-truncate flex-fill pt-1 pb-1" }

import {
    computed,
    getCurrentInstance,
    nextTick,
    onActivated,
    onMounted,
    ref,
} from 'vue';
import InfiniteScrollContainer from "~/core-ui/vue/InfiniteScrollContainer.vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import Dictionary from "~/ts/library/Dictionary";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import CoreUiChatHistory from "~/core-ui/vue/chat/CoreUiChatHistory.vue";
import WindowHelper from "~/ts/library/WindowHelper";
import Delay from "~/ts/library/Delay";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import OperatorApplicationHtmlify from "~/operatorApplication/vue/misc/OperatorApplicationHtmlify.vue";
import OperatorApplicationPlatform from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import MyLoader from "~/cabinet/vue/interface/data/MyLoader.vue";
import useActivated from "~/ts/vuePlugins/useActivated";

import Random from "~/ts/library/Random";
import ObjectHelper from "~/ts/library/ObjectHelper";
import CoreUiChatClientAvatar from "~/core-ui/vue/chat/CoreUiChatClientAvatar.vue";
import {MESSAGE_COLOR_OPERATOR_DARK} from "~/operatorApplication/vue/dialogs/dialog/Constants";

interface HistoryPartInterface {
    key: number,
    username: string,
    messages: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel[]
}



const __default__ = {
    name: "MultiContactDialogHistory"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    userdata: {},
    clients: {}
  },
  emits: ["open"],
  setup(__props: any, { emit: __emit }) {

const LIMIT = 30;

let props = __props;

let emits = __emit;

let chatScrollContainer = ref<HTMLDivElement>();

let instanceId = Random.uid();

let messages = ref<OperatorApplicationApi.OperatorApplicationMessageOpenApiModel[]>();
messages.value = [];
let isLoading = ref(false);
let isMounted = ref(false);
let isScrolledToBottom = ref(true);
let needToFetchOnActivate = ref(false);

let historyParts = computed<HistoryPartInterface[]>(() => {
    let result: HistoryPartInterface[] = [];
    let currentHistoryPart: HistoryPartInterface;
    for (let i = messages.value.length - 1; i >= 0; i--) {
        let message = messages.value[i];
        if (currentHistoryPart?.username != message.username) {
            currentHistoryPart = {
                key: message.id,
                username: message.username,
                messages: []
            };
            result.splice(0, 0, currentHistoryPart);
        }
        currentHistoryPart.messages.splice(0, 0, message);
    }
    return result;
});


let isActivated = useActivated();

let instance = getCurrentInstance().proxy;


onActivated(() => {
    scrollToBottom(0);
    if (needToFetchOnActivate.value) {
        needToFetchOnActivate.value = false;
        reloadMessages();
    }
});

async function reloadMessages() {
    messages.value.splice(0, messages.value.length);
    messages.value.push(...(await fetchMessages()));
    instance.$nextTick(async () => {
        scrollToBottom(0);
        await Delay.make(100);
        scrollToBottom(0);
        await Delay.make(100);
        scrollToBottom(0);
    });
}

let applicationPlatform = computed(() => {
    return OperatorApplicationPlatform;
});

let showOperatorLogins = computed(() => {
    return OperatorAccountStore.data.value.accessRights.canViewOperatorsLogin;
});


function scrollToBottom(duration: number = 100) {
    if (chatScrollContainer.value) {
        WindowHelper.scrollToBottom(chatScrollContainer.value, duration);
    }
}

let customOperatorStatusDictionary = OperatorAccountStore.customStatusDictionary;
let messageSourceTypeDictionary = OperatorAccountStore.messageSourceTypeDictionary;

async function onMessageHeightChange() {
    if (isScrolledToBottom.value) {
        try {
            await Delay.make(200, "dialogHistoryScroll", true);
            scrollToBottom();
        } catch (e) {

        }
    }
}

let you = OperatorAccountStore.operator;


onMounted(() => {
    isMounted.value = true;
    nextTick(() => {
        scrollToBottom(0);
    });
});

let htmlify = computed(() => {
    return OperatorApplicationHtmlify;
});

let operators = computed(() => {
    return OperatorAccountStore.data.value.operators;
});

let firstRealMessageId = computed(() => {
    return messages.value
        ?.find(message => !message.messageType || !message.messageType.isAutoMessage)
        ?.id;
});

let messageIds = computed(() => {
    let result: Dictionary<any> = {};
    for (let message of messages.value) {
        result[message.id] = true;
    }
    return result;
});

let usernames = computed(() => props.clients.map(client => client.username));

let userdataDictionary = computed(() => {
    return ObjectHelper.dictionaryFromArray(props.clients, "username");
});

async function fetchMessages(lastMessageId?: number, silent: boolean = true) {

    let p: OperatorApplicationApi.OperatorMessageGetOpenApiModel = {
        username: props.userdata.username,
        usernames: usernames.value,
        count: LIMIT,
        lastMessageId
    };
    if (firstRealMessageId.value) {
        p.firstMessageId = firstRealMessageId.value;
    }
    isLoading.value = true;
    let messages: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel[] = [];

    if (OperatorAccountStore.isAuthorized.value) {
        let error = false;
        try {
            let result = await (new OperatorApiRequest<OperatorApplicationApi.OperatorMessageGetResultOpenApiModel>({
                url: "/message/get",
                p,
                silent: silent,
                silentError: silent
            })).send();

            if (result.isSuccess) {
                let data = result.data;
                messages = data.messages.filter(message => !messageIds.value[message.id]);
            } else {
                error = true;
            }
        } catch (e) {
            error = true;
        }
        if (error) {
            reloadMessagesAfterError();
        }
    }

    isLoading.value = false;
    return messages;
}


async function reloadMessagesAfterError() {
    try {
        await Delay.make(3000, `reloadMessagesAfterError_${instanceId}`, true);
    } catch (e) {
        return;
    }
    if (isActivated.value) {
        reloadMessages();
    } else {
        needToFetchOnActivate.value = true;
    }
}


function openChatWith(username: string) {
    emits('open', username);
}


let operatorMessageBackground = computed(() => {
    return OperatorApplicationConfigInstance.darkThemeEnabled ? MESSAGE_COLOR_OPERATOR_DARK : OperatorApplicationConfigInstance.operatorMessageBackground;
});

let clientMessageBackground = computed(() => {
    return OperatorApplicationConfigInstance.darkThemeEnabled ? 'client-dark' : undefined;
});


let site = computed(() => OperatorAccountStore.sitesDictionary.value[props.userdata.siteId]);

let hasBackgroundImage = computed(() => {
    return !!OperatorApplicationConfigInstance.historyBackground && !OperatorApplicationConfigInstance.darkThemeEnabled;
});


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "absolute-full-size chat-scroll-container d-flex flex-column",
      style: _normalizeStyle({
                fontSize: `${_unref(OperatorApplicationConfigInstance).chatHistoryScale}em`
            }),
      ref_key: "chatScrollContainer",
      ref: chatScrollContainer
    }, [
      (_unref(isLoading))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass({'loader': true, 'small': !!_unref(historyParts).length})
          }, [
            _createElementVNode("div", null, [
              _createVNode(MyLoader, { big: "" })
            ])
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        (_unref(isMounted))
          ? (_openBlock(), _createBlock(InfiniteScrollContainer, {
              key: 0,
              "load-method": fetchMessages,
              "scroll-container": _unref(chatScrollContainer),
              items: _unref(messages),
              onScrolledToBottom: _cache[0] || (_cache[0] = ($event: any) => (_isRef(isScrolledToBottom) //@ts-ignore
 ? isScrolledToBottom.value = $event : isScrolledToBottom = $event))
            }, {
              default: _withCtx(({loading}) => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(historyParts), (history) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: history.key
                  }, [
                    _createVNode(CoreUiChatHistory, {
                      operators: _unref(operators),
                      "virtual-operators": _unref(site)?.virtualOperators,
                      messages: history.messages,
                      you: _unref(you),
                      client: _unref(userdataDictionary)[history.username],
                      "show-seconds": _unref(OperatorApplicationConfigInstance).showSecondsInChat,
                      "operator-message-background": _unref(operatorMessageBackground),
                      "client-message-background": _unref(clientMessageBackground),
                      "show-dialog-info": false,
                      "show-operator-group": _unref(site)?.isShowOperatorGroupInChat ?? false,
                      "has-background-image": _unref(hasBackgroundImage),
                      "show-answered-not-in-time-messages": _unref(OperatorApplicationConfigInstance).showAnsweredNotInTimeMessages,
                      "scroll-container": _unref(chatScrollContainer),
                      htmlify: _unref(htmlify),
                      "operator-application-platform": _unref(applicationPlatform),
                      "show-operator-logins": _unref(showOperatorLogins),
                      "custom-operator-status-dictionary": _unref(customOperatorStatusDictionary),
                      "message-source-type-dictionary": _unref(messageSourceTypeDictionary),
                      onMessageHeightChange: onMessageHeightChange
                    }, {
                      before: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex-fill" }, null, -1)),
                          _createVNode(_component_el_button, {
                            onClick: ($event: any) => (openChatWith(history.username)),
                            round: "",
                            plain: "",
                            type: "info",
                            style: {"height":"auto"},
                            class: "mr-1 ml-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(CoreUiChatClientAvatar, {
                                client: _unref(userdataDictionary)[history.username],
                                "integration-platform": _unref(OperatorAccountStore).integrationPlatformDictionary.value[_unref(userdataDictionary)[history.username].integration?.aggregationPlatformId ?? _unref(userdataDictionary)[history.username].integration?.platformId],
                                size: "1.8em",
                                class: "mr-2"
                              }, null, 8, ["client", "integration-platform"]),
                              _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(userdataDictionary)[history.username].displayDescr), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex-fill" }, null, -1))
                        ])
                      ]),
                      _: 2
                    }, 1032, ["operators", "virtual-operators", "messages", "you", "client", "show-seconds", "operator-message-background", "client-message-background", "show-operator-group", "has-background-image", "show-answered-not-in-time-messages", "scroll-container", "htmlify", "operator-application-platform", "show-operator-logins", "custom-operator-status-dictionary", "message-source-type-dictionary"])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["scroll-container", "items"]))
          : _createCommentVNode("", true)
      ])
    ], 4)
  ]))
}
}

})